import { render, staticRenderFns } from "./ColorSelectionMenu.vue?vue&type=template&id=0c29f9cc&scoped=true"
import script from "./ColorSelectionMenu.vue?vue&type=script&lang=js"
export * from "./ColorSelectionMenu.vue?vue&type=script&lang=js"
import style0 from "./ColorSelectionMenu.vue?vue&type=style&index=0&id=0c29f9cc&prod&lang=scss&scoped=true"
import style1 from "./ColorSelectionMenu.vue?vue&type=style&index=1&id=0c29f9cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c29f9cc",
  null
  
)

export default component.exports